import { instance2 } from './base';

export const getStores = () =>
    instance2
        .get('/api/v1/store', {
            params: {},
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
export const getBranches = () =>
    instance2
        .get('/api/v1/store/branch', {
            params: {},
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const searchSerialNumber = (serialNumber) =>
    instance2
        .get('/api/v1/products/inventories', {
            params: {
                serial_number: serialNumber,
            },
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const getCustomerProduct = () =>
    instance2
        .get('/api/v1/warranty/ewarranty/customer-products', {})
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const registerWarranty = (data) =>
    instance2
        .post('/api/v1/warranty/ewarranty', data, {})
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const getUploadUrl = (data) =>
    instance2
        .put('/api/v1/cloud/files/pre-sign-url', data, {})
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
